export default class BirthdayReminder {
  constructor(name, surname, date) {
    this.name = name
    this.surname = surname
    this.birthdayDate = date
  }
}
